import ReactTooltip from 'react-tooltip'

import PermissionIcon from './PermissionIcon/index'

const UserPermissionColumn = ({ category, children, showHeader = true }) => {
  return (
    <div className="userPermissionColumn">
      <ReactTooltip />
      {showHeader && (
        <div className="userPermissionColumn__header">
          <PermissionIcon name={category} />
          {category}
        </div>
      )}
      <div className="userPermissionColumn__content">{children}</div>
    </div>
  )
}

export default UserPermissionColumn
